module.exports = __webpack_public_path__ + "static/media/isoLogo-dark.faf4d876.svg";